import { CALENDAR_GRID_LABEL_SEPARATOR } from '../../../../constants/calendarGrid'
import Text from '../../../Text'
import { UserAvatarGroup } from '../../../User'

import {
  hasCalendarItemCardDetails,
  hasCalendarItemCardDetailsSeparator,
} from './CalendarItemCardDetails.utils'

import * as styles from './CalendarItemCardDetails.module.css'

function CalendarItemCardDetails({ address, people }) {
  return hasCalendarItemCardDetails({ address, people }) ? (
    <div className={styles.CalendarItemCardDetails}>
      <UserAvatarGroup users={people} />
      {hasCalendarItemCardDetailsSeparator({ address, people }) ? (
        <Text isSecondary>{CALENDAR_GRID_LABEL_SEPARATOR.trim()}</Text>
      ) : null}
      {address ? (
        <Text isSecondary className={styles.address}>
          {address}
        </Text>
      ) : null}
    </div>
  ) : null
}

export default CalendarItemCardDetails
